import 'css-chunksrc/client/scenes/workloads/wbs/event/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_5csej_1",
  "form": "_form_5csej_6",
  "hovered": "_hovered_5csej_10",
  "name": "_name_5csej_1",
  "icon": "_icon_5csej_32",
  "input": "_input_5csej_36",
  "edition": "_edition_5csej_57",
  "tooltip": "_tooltip_5csej_64"
};